'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import Button from '@/shared/Buttons/Button';
import { ROUTES } from '@/forApp/utils/routes';

import styles from './styles.module.css';

const NewServiceLink = () => {
  const router = useRouter();
  return (
    <div className={styles.newBlockService}>
      <h4>У бюро новые услуги!</h4>
      <ul>
        <li>Изготовление рекламных вывесок</li>
        <li>Вскрытие замков</li>
        <li>Клининг</li>
        <li>И ещё 32 услуги</li>
      </ul>
      <Button
        color={'white'}
        text={'Смотреть все'}
        onClick={() => router.push(ROUTES.SERVICES)}
      />
      <Image
        alt={'Новые услуги'}
        width={175}
        height={181}
        src={`/imgs/objects.webp`}
        className={styles.img}
      />
    </div>
  );
};

export default NewServiceLink;
